import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Payments from './views/Payments';
import PayWithCard from './views/PayWithCard';
import Landing from './views/Landing';

window.recaptchaOptions = {
  useRecaptchaNet: true,
  enterprise: true,
  event: "suscriptor",
};

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Montserrat"
        }
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/pay-with-card" element={<PayWithCard />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
